import { useEffect, useState } from 'react';
import ButtonItem from '../../components/ButtonItem';

export default function UploadSchedule() {
  const [folders, setFolders] = useState([]);
  const [folder, setFolder] = useState('');
  const [channels, setChannels] = useState([]);
  const [selected, setSelected] = useState([]);
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [intervalMin, setIntervalMin] = useState('60'); // 30/60/커스텀
  const [title, setTitle] = useState('');
  const [descTmpl, setDescTmpl] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const API = process.env.REACT_APP_API_URL;

  const toggle = (id) =>
    setSelected((s) =>
      s.includes(id) ? s.filter((x) => x !== id) : [...s, id]
    );

  useEffect(() => {
    (async () => {
      try {
        const f = await fetch('/upload/folders').then((r) => r.json());
        setFolders(f?.folders || []);
        if (f?.folders?.length) setFolder(f.folders[0]);
        const c = await fetch('/youtube/channels').then((r) => r.json());
        setChannels(c?.channels || []);
      } catch {
        setMsg('목록 조회 실패');
      }
    })();
  }, []);

  const submit = async () => {
    if (!folder) return alert('폴더 선택');
    if (!selected.length) return alert('채널 선택');
    if (!start || !end) return alert('기간 선택');
    if (!title) return alert('제목 입력');
    const im = Math.max(1, Number(intervalMin || '60'));
    setLoading(true);
    setMsg('');
    try {
      const r = await fetch('/upload/schedule', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          folder,
          channelIds: selected,
          start,
          end,
          intervalMinutes: im,
          title,
          descTemplate: descTmpl,
        }),
      });
      if (!r.ok)
        throw new Error((await r.json()).errorMessage || '스케줄 생성 실패');
      setMsg('✅ 스케줄 생성 완료');
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-dvh h-dvh flex flex-col items-center overflow-y-auto p-12">
      <div className="w-full mb-10 text-3xl text-center font-bold">
        업로드 스케줄
      </div>

      <div className="w-[500px] flex flex-col space-y-6">
        <div>
          <label className="block text-lg font-semibold mb-1">
            폴더 (output 하위)
          </label>
          <select
            className="w-full h-12 px-3 py-2 rounded-xl border"
            value={folder}
            onChange={(e) => setFolder(e.target.value)}>
            {folders.map((f) => (
              <option key={f} value={f}>
                {f}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-lg font-semibold mb-2">채널 선택</label>
          <div className="space-y-2">
            {channels.map((c) => (
              <label key={c.id} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={selected.includes(c.id)}
                  onChange={() => toggle(c.id)}
                />
                <span>{c.title}</span>
              </label>
            ))}
            <a
              href={`${API}/youtube/auth`}
              className="text-sky-600 underline text-sm">
              + 새 채널 연결 (Google OAuth)
            </a>
          </div>
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">시작일</label>
          <input
            type="date"
            className="w-full h-12 px-3 py-2 rounded-xl border"
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">종료일</label>
          <input
            type="date"
            className="w-full h-12 px-3 py-2 rounded-xl border"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">간격(분)</label>
          <input
            type="text"
            inputMode="numeric"
            value={intervalMin}
            onChange={(e) =>
              setIntervalMin(e.target.value.replace(/[^0-9]/g, ''))
            }
            className="w-full h-12 px-3 py-2 rounded-xl border"
            placeholder="예) 30 / 60"
          />
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">제목</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full h-12 px-3 py-2 rounded-xl border"
            placeholder="영상 제목을 입력하세요"
          />
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">설명</label>
          <textarea
            value={descTmpl}
            onChange={(e) => setDescTmpl(e.target.value)}
            className="w-full h-24 px-3 py-2 rounded-xl border"
            placeholder="영상 설명을 입력하세요"
          />
        </div>

        <div className="pt-2">
          <ButtonItem
            text={loading ? '스케줄 생성 중...' : '스케줄 생성'}
            color="blue"
            className="w-full h-14 rounded-xl text-xl"
            onClick={submit}
            disabled={loading}
          />
        </div>

        {msg && <div className="text-sm">{msg}</div>}
      </div>
    </div>
  );
}
